import {type RumGlobal} from '@datadog/browser-rum';

import {RunsLinePlotConfig} from '../../types';

export function checkBackendLinesSupport({
  config,
  datadogRum,
  panelId,
  usesBackendLineConstruction,
  usesBackendLineConstructionMultiMetric,
  usesBackendLineConstructionSmoothing,
}: {
  config: RunsLinePlotConfig;
  datadogRum: RumGlobal;
  panelId?: string;
  usesBackendLineConstruction: boolean;
  usesBackendLineConstructionMultiMetric: boolean;
  usesBackendLineConstructionSmoothing: boolean;
}) {
  const sharedContext = {
    panelId,
    usesBackendLineConstruction,
  };

  // multiple metrics require feature flag
  if (
    config.metrics &&
    config.metrics.length > 1 &&
    !usesBackendLineConstructionMultiMetric
  ) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'multiple metrics',
      ...sharedContext,
    });
    return false;
  }

  if (config.expressions) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'y-axis expressions',
      ...sharedContext,
    });
    return false;
  }

  if (config.xExpression) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'x-axis expressions',
      ...sharedContext,
    });
    return false;
  }

  if (
    config.smoothingWeight &&
    config.smoothingWeight > 0 &&
    !usesBackendLineConstructionSmoothing
  ) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'smoothing',
      ...sharedContext,
    });
    return false;
  }

  // log scales not yet supported
  if (config.xLogScale || config.yLogScale) {
    datadogRum.addAction('backend lines not supported', {
      reason: 'log scales',
      ...sharedContext,
    });
    return false;
  }

  // cannot exclude outliers yet
  if (config.excludeOutliers === 'exclude-outliers') {
    datadogRum.addAction('backend lines not supported', {
      reason: 'exclude outliers',
      ...sharedContext,
    });
    return false;
  }

  // cannot do backend lines for non-bucketing, should never be hit
  if (config.pointVisualizationMethod !== 'bucketing-gorilla') {
    datadogRum.addAction('backend lines not supported', {
      reason: 'non-bucketing visualization method',
      ...sharedContext,
    });
    return false;
  }

  return true;
}
